import $ from 'jquery'
import 'owl.carousel';

export const destroyOwlCarousel = (el) => {
  let $carousel = $(el)
  if ($carousel.length > 0) {
    $carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded')
    $carousel.find('.owl-stage-outer').children().unwrap()
  }
}

export const initOwlCarousel = (el, params) => {    
  let $carousel = $(el)
  if ($carousel.length > 0) {
    $carousel.addClass('owl-carousel')
    $carousel.owlCarousel(params)
  }
  return $carousel
}

export const refreshOwlCarousel = (el, params) => {
  destroyOwlCarousel(el)
  initOwlCarousel(el, params)
}